export const useDeviceType = () => {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && window.innerWidth < 1200) {
        if (window.innerWidth > 768) {
            return 'table'
        }
        return 'phone'
    } else {
        return 'desktop'
    }
}